/** Must match `.spark-modal-portal-root` on SparkModalPortal. */
export const SPARK_MODAL_PORTAL_ROOT_CLASS = 'spark-modal-portal-root';

/**
 * Parent node for a portaled overlay panel.
 *
 * Page overlays portal to `document.body` at z-index 1100 so they slide under
 * the sticky navbar (1200). Overlays opened inside a Spark modal portal into
 * that modal's root instead, so they stack in the modal's 1300 context and
 * stay above the dialog — a body portal at 1100 would paint behind the mask.
 */
export function getOverlayPortalParent(trigger: HTMLElement | null): HTMLElement {
  const modalRoot = trigger?.closest(`.${SPARK_MODAL_PORTAL_ROOT_CLASS}`);
  return modalRoot instanceof HTMLElement ? modalRoot : document.body;
}
